export class DashboardSearchParameters {

    buyerID: number = 0;
    regionID: number = 0;
    compliant: boolean = true;
    nonCompliant: boolean = true;

}